import { useEffect, useRef, useState, ReactNode } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import type { RootState } from '../../types/store'
import { Fullscreen } from 'lucide-react';

type FullScreenProps = {
    popup: boolean;
    isFullScreen: boolean;
    onFullScreen: () => void;
    children: ReactNode;
}

export default function FullScreenPopup({ popup, isFullScreen, onFullScreen, children }: FullScreenProps) {
    const [open, setOpen] = useState(popup);
    const translate = useSelector((state: RootState) => state.ui.language.fullscreen);

    const hasFired = useRef(false);
    useEffect(() => {
        if (!hasFired.current) {
            setOpen(popup);
        }

        hasFired.current = true;
    }, []);

    const handleClose = () => {
        setOpen(false);
    };

    const isFullscreenSupported = typeof document !== "undefined" && (() => {
        const el = document.createElement('div');
        return !!(
            el.requestFullscreen ||
            (el as any).webkitRequestFullscreen ||
            (el as any).mozRequestFullScreen ||
            (el as any).msRequestFullscreen
        );
    })();

    return (
        <>
            {!isFullScreen && isFullscreenSupported && <div onClick={onFullScreen} style={{ cursor: 'pointer', position: 'fixed', left: 0, top: 0, zIndex: 100 }}><Fullscreen /></div>}
            <Dialog open={open && isFullscreenSupported} aria-labelledby="responsive-dialog-title">
                <DialogContent>
                    <center>
                        <Typography>
                            {translate.question}
                        </Typography>
                    </center>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="error">
                        {translate.no}
                    </Button>
                    <Button onClick={() => { onFullScreen(); handleClose(); }} variant="contained">
                        {translate.yes}
                    </Button>
                </DialogActions>
            </Dialog>
            {children}
        </>
    );
}
